import { AdeMesError } from "./commonClasses";

declare var angular: any;

module CommonUtils {

    export interface ICommonUtils {
        printError: (error: AdeMesError) => void;
        paramToDate: (dateParam: any) => Date;
    }

    export class CCommonUtils implements ICommonUtils {
        constructor(
            protected $state: angular.ui.IStateService,
            protected $translate: angular.translate.ITranslateService,
            protected toaster: toaster.IToasterService,
            protected moment: any
        ) {
        };

        public printError = (error: AdeMesError): void => {
            let errorMsg = this.$translate.instant("toaster.error.unexpected-error");
            if (error && error.message) {
                errorMsg = error.message;
            }
            if (error && error.data && error.data.error) {
                errorMsg = error.data.error;
            }
            if (error && error.status && error.status === 401) {
                errorMsg = this.$translate.instant("toaster.error.user-not-authorized");
                this.$state.go("login");
            }
            this.toaster.pop("error", this.$translate.instant("toaster.error.title"), errorMsg);
        };

        public paramToDate = (dateParam: any): Date => {
            if (!dateParam || dateParam === undefined || dateParam === null || dateParam === "") {
                return null;
            }

            let retDate: Date = dateParam;
            if (typeof dateParam === "object") {
                retDate = <Date>dateParam;
            } else if (typeof dateParam === "string") {
                retDate = this.moment(<string>dateParam).toDate();
            }

            return retDate;
        };
    }

    angular.module("AdeMesApp").factory("CommonUtils", ($state: angular.ui.IStateService, $translate: angular.translate.ITranslateService, toaster: toaster.IToasterService, moment: any) => new CommonUtils.CCommonUtils($state, $translate, toaster, moment));
}